import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

export const scrollToId = (id) => {
    if (lenisInstance) {
        lenisInstance.scrollTo(id, { offset: -72, duration: 1.4 });
    } else {
        document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
    }
};

export const scrollToTop = () => {
    if (lenisInstance) {
        lenisInstance.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo(0, 0);
};

export const preselectService = (service) => {
    window.dispatchEvent(new CustomEvent("preselect-service", { detail: service }));
    scrollToId("#angebot");
};

export function useLenis() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        lenisInstance = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            lenisInstance = null;
        };
    }, []);
}
